<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { ClientSettings, GetClientsWidgetDataViewModel } from '@/lib/types'
import { generateField } from '@/lib/utils'
import ClientsRepository from '@/repository/ClientsRepository'
import CardInfoContent from '@/components/ui/card/CardInfoContent.vue'
import { usePercentageMode } from '@/lib/usePercentageMode'
import Card from '@/components/ui/card/Card.vue'

const infoCardFields = ref<
  {
    label: string
    value: number
    percentage?: number
    color?: string
  }[]
>([])
const infoCardData = ref<GetClientsWidgetDataViewModel | null>()
const settings = ref<ClientSettings | null>(null)
const { isPercentageMode } = usePercentageMode(false)

const updateInfoCardFields = () => {
  if (infoCardData.value && settings.value) {
    infoCardFields.value = [
      generateField(
        settings.value,
        infoCardData.value,
        'Nombre de clients entreprises',
        'total_client_entreprise',
        'global',
      ),
      generateField(
        settings.value,
        infoCardData.value,
        'Nombre de clients personnes',
        'total_client_personne',
        'global',
      ),
      generateField(
        settings.value,
        infoCardData.value,
        'Nouveaux clients entreprises',
        'total_new_clients_entreprise',
        '18 derniers mois',
        'Nouveaux clients entreprises',
      ),
      generateField(
        settings.value,
        infoCardData.value,
        'Nouveaux clients personnes',
        'total_new_clients_personne',
        '18 derniers mois',
        'Nouveaux clients personnes',
      ),
    ]
  }
}

onMounted(async () => {
  infoCardData.value = await ClientsRepository.getInfoCardData()
  settings.value = await ClientsRepository.getSettings()
  updateInfoCardFields()
})
</script>

<template>
  <Card
    title="Clients"
    :settings="settings"
    settings-url="api/widgets/card-clients/settings"
    v-model:percentage-mode="isPercentageMode"
    :percent-icon="true"
  >
    <CardInfoContent
      :fields="infoCardFields || []"
      :skeletons="4"
      :percentage-mode="isPercentageMode"
    />
  </Card>
</template>
